import React, { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";

import Settings from "./Pages/Settings";
import Buttons from "./Pages/Buttons";
import RelatedList from "./Pages/RelatedList";
import CustomAction from "./Pages/CustomAction";
import "./App.css";
import Wizards from "./Pages/Wizards";

const router = createBrowserRouter([
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/relatedlist",
    element: <RelatedList />,
  },
  {
    path: "/buttons",
    element: <Buttons />,
  },
  {
    path: "/wizards",
    element: <Wizards />,
  },
  {
    path: "/customaction",
    element: <CustomAction />,
  },
]);

function App() {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // useEffect(() => {
  //   // Dynamically load Google Maps API with custom inline script
  //   const script = document.createElement("script");

  //   // Inline script content for Google Maps API
  //   script.innerHTML = `(g => {
  //       var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
  //       b = b[c] || (b[c] = {});
  //       var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => {
  //         await (a = m.createElement("script"));
  //         e.set("libraries", [...r] + "");
  //         for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
  //         e.set("callback", c + ".maps." + q);
  //         a.src = \`https://maps.\${c}apis.com/maps/api/js?\` + e;
  //         d[q] = f;
  //         a.onerror = () => h = n(Error(p + " could not load."));
  //         a.nonce = m.querySelector("script[nonce]")?.nonce || "";
  //         m.head.append(a);
  //       }));
  //       d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
  //     })({ key: "AIzaSyAMO0ijfhLVS1JHQvHzP5BuQtKsVIUI8Js", v: "beta" });`;

  //   // Append the script to the document head
  //   document.head.appendChild(script);
  //   setScriptLoaded(true);
  //   // Clean up the script on component unmount
  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);

  // useEffect(() => {
  //   // Initialize the map and autocomplete once the Google Maps API is loaded
  //   const initMap = async () => {
  //     try {
  //       // Request needed libraries.
  //       // eslint-disable-next-line no-undef
  //       const places = await google.maps.importLibrary("places");

  //       // Create the PlaceAutocompleteElement for search input
  //       const placeAutocomplete =
  //         // eslint-disable-next-line no-undef
  //         new google.maps.places.PlaceAutocompleteElement({
  //           componentRestrictions: {
  //             country: ["us", "au"],
  //           },
  //           requestedLanguage: "fr",
  //         });

  //       // Append autocomplete element to a container
  //       document
  //         .getElementById("autocomplete-container-2")
  //         .appendChild(placeAutocomplete);

  //       // Inject UI elements to display selected place information
  //       const selectedPlaceTitle = document.createElement("p");
  //       const selectedPlaceInfo = document.createElement("pre");

  //       selectedPlaceTitle.textContent = "";
  //       selectedPlaceInfo.textContent = "";

  //       document
  //         .getElementById("info-container-2")
  //         .appendChild(selectedPlaceTitle);
  //       document
  //         .getElementById("info-container-2")
  //         .appendChild(selectedPlaceInfo);

  //       // Add listener for place selection
  //       placeAutocomplete.addEventListener(
  //         "gmp-placeselect",
  //         async ({ place }) => {

  //           await place.fetchFields({
  //             fields: [
  //               "displayName",
  //               "formattedAddress",
  //               "location",
  //               "addressComponents",
  //             ],
  //           });

  //           selectedPlaceTitle.textContent = "Selected Place:";
  //           selectedPlaceInfo.textContent = JSON.stringify(
  //             place.toJSON(),
  //             null,
  //             2
  //           );
  //         }
  //       );
  //     } catch (error) {
  //       console.error("Error loading Google Maps or Places API:", error);
  //     }
  //   };

  //   // Call the initMap function once the API is loaded
  //   // eslint-disable-next-line no-undef
  //   if (window.google && google.maps && scriptLoaded) {
  //     initMap();
  //   }

  //   // Cleanup function on component unmount
  //   return () => {
  //     // Any necessary cleanup, if needed
  //   };
  // }, [scriptLoaded]);
  return (
    <>
      {/* <div id="autocomplete-container-2"></div>
      <div id="info-container-2"></div> */}
      <RouterProvider router={router} />
    </>
  );
}

export default App;
